import { combineEpics } from 'redux-observable';
import attributes from './attributes';
import emailAddress from './emailAddress';
import emails from './emails';
import permissions from './permissions';
import profile from './profile';
import profileOptions from './profileOptions';
import alerts from './alerts';
import notifications from './notifications';
import hubContact from './hubContact';
import hubUsers from './hubUsers';
import avatar from './avatar';
import unrecoverableErrors from './unrecoverableErrors';
import twoFactorAuth from './twoFactorAuth';
import portalSettings from './portalSettings';
import loginEmails from '../login-emails/epics';
import sendAsEmails from '../send-as-emails/epics';
import navConfig from './navConfig';
import userCanGdprDeleteSelf from './userCanGdprDeleteSelf';
import messageSettings from './messageSettings';
import securityPhoneNumber from './security/securityPhoneNumber';
export default combineEpics(attributes, emailAddress, emails, permissions, unrecoverableErrors, profileOptions, hubContact, hubUsers, avatar, alerts, notifications, profile, securityPhoneNumber, twoFactorAuth, portalSettings, loginEmails, sendAsEmails, navConfig, userCanGdprDeleteSelf, messageSettings);